import React from 'react';

import reduce from 'lodash/reduce';
import find from 'lodash/find';
import toUpper from 'lodash/toUpper';

import { Intent } from '@blueprintjs/core';

export const getMaxDate = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 5);
  date.setMonth(11, 31);
  return date;
};

export const setAllValues = (collection, value) =>
  reduce(
    collection,
    (result, _, key) => {
      result[key] = value;
      return result;
    },
    {}
  );

export const fileTypeFilter = file => {
  const whiteList = [
    'pdf',
    'txt',
    'doc',
    'docx',
    'odt',
    'xls',
    'xlsx',
    'ods',
    'ppt',
    'pptx',
    'html',
	'htm',
	'msg',
  ];
  const extension = file.name.substr(file.name.lastIndexOf('.') + 1);
  return !(
    (file.type.includes('application') &&
      (file.type.includes('microsoft.portable-executable') ||
        file.type.includes('msdownload'))) ||
    !whiteList.includes(extension)
  );
};

export const getDashboardHeaders = [
  'Reference Number',
  'Sponsor',
  'Product or Service',
  'Date Created',
  'Date Last Modified',
  'Status',
];
export const getDashboardFields = [
  ['vendorRequestID'],
  ['sponsorInformation', 'email'],
  ['productServiceName'],
  ['requestSubmittedDate'],
  ['lastModifiedDate'],
  ['requestStatus'],
];

export const pluckFromArray = (arr, key, val) => find(arr, [key, val]);

export const iconPicker = statusCategory => {
  if (statusCategory === 'Pending')
    return { icon: 'TIME', intent: Intent.PRIMARY };
  if (statusCategory === 'Pass')
    return { icon: 'TICK_CIRCLE', intent: Intent.SUCCESS };
  if (statusCategory === 'Fail')
    return { icon: 'DELETE', intent: Intent.DANGER };
  if (statusCategory === 'Review')
    return { icon: 'ERROR', intent: Intent.WARNING };
  return { icon: 'SUCCESS', intent: Intent.SUCCESS };
};

export const filterRequestsByReviewable = (data) => {
	return data.filter(request => request.DepartmentalReviews.length > 0);
}

export const filterRequestsByOwned = (data) => {
	return data.filter(request => request.sponsorInformation.currentUser);
};


/**
 * Filters an array of request objects by category
 * @param {*} data - array of request objects returned from API
 * @param {*} category - a string representing the category filter
 */
export const filterRequestsByCategory = (data, category) => {
  let filteredData = [];
  data.forEach(item => {
    if (item.statusCategory.toLowerCase() === category.toLowerCase()) {
      filteredData.push(item);
    }
  });
  return filteredData;
};

/**
 * Filters an array of request objects by removing a category
 * @param {*} data - array of request objects returned from API
 * @param {*} category - a string representing the category filter
 */
export const filterOutRequestsByCategory = (data, category) => {
  let filteredData = [];
  data.forEach(item => {
    if (item.statusCategory.toLowerCase() !== category.toLowerCase()) {
      filteredData.push(item);
    }
  });
  return filteredData;
};

/**
 * Filters an array of request objects by status
 * @param {*} data - array of request objects returned from API
 * @param {*} status - a string representing the status filter
 */
export const filterRequestsByStatus = (data, status) => {
  let filteredData = [];
  data.forEach(item => {
    if (item.requestStatus.toLowerCase() === status.toLowerCase()) {
      filteredData.push(item);
    }
  });
  return filteredData;
};

export const If = ({ condition, children }) => {
  if (condition) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return null;
  }
};

export const download = ({ data }, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  // 3. Append to html page
  document.body.appendChild(link);
  // 4. Force download
  link.click();
  // 5. Clean up and remove the link
  link.parentNode.removeChild(link);
};

export const findValue = (coll, key, value, valueKey) => {
  const val = find(coll, [key, value]);
  if (val === undefined) {
    return '';
  } else {
    return val[valueKey];
  }
};

// used to conditionally render icons/words for questionnaire management tabs based on status of questions/answers
export const statusByVersionStatus = versionStatus => {
  return {
    getStatus: versionStatus === 'Active' ? 'Archive' : 'Remove',
    getIcon: versionStatus === 'Active' ? 'PROJECTS' : 'TRASH',
    getTitle:
      versionStatus === 'Active' ? 'Archive Question' : 'Remove Question',
    getBody:
      versionStatus === 'Active'
        ? 'This question is published. Questionnaires that are in progress or previously completed will still reference this question.'
        : 'This question has not been published and will be permanently deleted.',
    getBodyAnswer:
      versionStatus === 'Active'
        ? 'This answer is published. Selecting remove will make this answer no longer an option.'
        : 'This answer has not been published and will be permanently deleted.',
    getConfirm: versionStatus === 'Active' ? 'ARCHIVE' : 'REMOVE',
  };
};

export const shouldBold = (value, query) => {
  if (!!query) {
    return toUpper(value).includes(toUpper(query)) ? (
      <strong>{value}</strong>
    ) : (
      value
    );
  } else {
    return value;
  }
};
